import type { LucideIcon } from "lucide-react";
import type { ComponentType } from "react";

import type { ThemeToken } from "./tokens";

/** The built-in theme a theme layers on: its index.css block and every `dark:` variant still apply. */
export type ThemeBase = "light" | "dark";

/** Where `ThemeBackdrop` renders a theme's decorative layer. App-wide decoration goes on `body` in the theme's CSS. */
export type ThemeBackdropSlot = "auth";

export type ThemeDefinition<Id extends string = string> = {
  id: Id;
  label: string;
  icon: LucideIcon;
  base: ThemeBase;
  /** Overrides of index.css variables. A token left out keeps the base theme's value. */
  tokens?: Partial<Record<ThemeToken, string>>;
  backdrops?: Partial<Record<ThemeBackdropSlot, ComponentType>>;
};

/** Snapshot ThemeProvider stores so the pre-React script in index.html can paint the theme before React mounts. */
export type ThemeSnapshot = {
  id: string;
  base: ThemeBase;
  vars: Record<string, string>;
};

export function defineTheme<const Id extends string>(theme: ThemeDefinition<Id>): ThemeDefinition<Id> {
  return theme;
}
